import Minus from "./Minus";
import Plus from "./Plus";

const iconMap = {
  plus: Plus,
  minus: Minus,
};

export default iconMap;
